import { BlockComponent, truncArray } from '../../../../lib'
import { Grid } from 'components/layout/primitives'
import { GridItem } from './GridItem'
import { LoadingApprovability, useApprovabilityData } from '../store'
import { SuspenseErrorBoundary } from 'components/patterns/suspense/internals/SuspenseErrorBoundary'

interface Props {
	institutions: LoadingApprovability['institutions']
}
const DynamicGridValues: BlockComponent<Props> = ({ institutions }) => {
	return (
		<>
			{truncArray(institutions, 8).map(({ provider, summary, loading }) => {
				return <GridItem key={provider.uuid} provider={provider} value={loading ? undefined : summary.level} />
			})}
		</>
	)
}

const FallbackGrid = () => {
	const [results] = useApprovabilityData()
	return <DynamicGridValues institutions={results.institutions} />
}

export const InstitutionsGrid: BlockComponent = () => (
	<Grid columnWidth={140}>
		<SuspenseErrorBoundary>
			<FallbackGrid />
		</SuspenseErrorBoundary>
	</Grid>
)
